/* =====================================================================
   GEC — AJAX add-to-cart for GEC buttons.
   Intercepts the GEC product-card and PDP add-to-cart forms (which otherwise
   POST to /cart and navigate to the cart page), adds via /cart/add.js, and opens
   the Minimog cart drawer instead — cleaner path to purchase. Falls back to a
   normal submit if the drawer isn't present or the request fails.
   (Cart-rewards reconciliation still runs via its own fetch backstop.)
   ===================================================================== */
(function () {
  var SEL = 'form.gec-card-form, form[data-gec-pdp-form]';

  function drawerEl() { return document.querySelector('m-cart-drawer'); }

  function sectionIds() {
    var d = drawerEl();
    if (!d || !d.getSectionsToRender) return null;
    var ids = [];
    d.getSectionsToRender().forEach(function (e) { if (ids.indexOf(e.id) < 0) ids.push(e.id); });
    return ids;
  }

  function openDrawer(res) {
    var d = drawerEl();
    if (d && typeof d.renderContents === 'function' && res && res.sections) { d.renderContents(res); return; }
    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    }
  }

  function showError(form, j) {
    var btn = form.querySelector('[type="submit"]');
    var note = form.querySelector('[data-gec-atc-error]');
    if (!note) {
      note = document.createElement('div');
      note.setAttribute('data-gec-atc-error', '');
      note.className = 'gec-atc-error';
      (btn && btn.parentNode ? btn.parentNode : form).appendChild(note);
    }
    note.textContent = (j && (j.description || j.message)) || 'Sorry, this could not be added to your cart.';
  }

  function onSubmit(e) {
    var form = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!form) return;
    if (!drawerEl()) return; // no cart drawer on this store → let it post to /cart normally

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      if (btn.getAttribute('aria-busy') === 'true') return; // guard double-submit
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('gec-atc--loading');
    }
    var prevErr = form.querySelector('[data-gec-atc-error]');
    if (prevErr) prevErr.remove();

    var fd = new FormData(form);
    var ids = sectionIds();
    if (ids) { fd.append('sections', ids.join(',')); fd.append('sections_url', window.location.pathname); }

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || (res.j && res.j.status)) { showError(form, res.j); return; }
        if (res.j && typeof res.j.item_count === 'number') setCount(res.j.item_count);
        openDrawer(res.j);
      })
      .catch(function () { form.submit(); }) // network issue → fall back to normal add
      .then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('gec-atc--loading'); }
      });
  }

  // ---------- cart count bubble sync (update on every cart change, not just page refresh) ----------
  function setCount(n) {
    n = parseInt(n, 10) || 0;
    document.querySelectorAll('[data-gec-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    document.querySelectorAll('.m-cart-count-bubble, .m-cart-count').forEach(function (el) { el.textContent = n; });
  }
  var countTimer;
  function syncCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }, 60);
  }
  // backstop: catch every cart mutation regardless of source (theme add, gift auto-add, qty/remove)
  if (window.fetch && !window.__gecCountPatched) {
    window.__gecCountPatched = 1;
    var _origFetch = window.fetch;
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = _origFetch.apply(this, arguments);
      try { if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { syncCount(); }).catch(function () {}); } catch (e) {}
      return p;
    };
  }
  if (window.MinimogEvents && MinimogEvents.subscribe && window.MinimogTheme && MinimogTheme.pubSubEvents) {
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, syncCount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCount); else syncCount();

  document.addEventListener('submit', onSubmit, true);
})();
